import Cookies from "universal-cookie";
import {
  REMOVE_ACCOUNT_DATA,
  GET_ACCOUNT_DATA,
  GET_HOW_IT_WORKS_CMS_DATA,
  GET_PAYMENT_TYPE_DETAILS,
  PAYMENT_HISTORY,
  SUBSCRIBED,
  GET_IS_PRO_MEMBER,
  GET_ACCOUNT_DATA_LOADER,
  GET_ACCOUNT_LOADER,
  INITIAL_LOADER,
} from "./constants";

const cookie = new Cookies();
const user_info = cookie.get("user_info");
const init = {
  user_info: {
    auth_token: cookie.get("user_token"),
    subscription_type: user_info?.subscription_type,
    email_verified_at: user_info?.email_verified_at,
    is_free_trial: user_info?.is_free_trial,
    type: user_info?.type,
    is_pro: user_info?.is_pro,
    role: user_info?.role,
    global_popup: user_info?.global_popup,
    name: user_info?.name,
  },
  paymenthistory: {},
  customer_payment_method: {},
  is_pro_member: 0,
  userLoader: false,
  loader: false,
  initialLoader: false,
};

const accountReducers = (state = init, action) => {
  switch (action.type) {
    case GET_ACCOUNT_DATA_LOADER:
      return {
        ...state,
        userLoader: action.payload,
      };
    case GET_ACCOUNT_DATA: {
      return {
        ...state,
        user_info: action.payload.data,
      };
    }
    case REMOVE_ACCOUNT_DATA: {
      return {
        ...state,
        user_info: {},
      };
    }
    case PAYMENT_HISTORY: {
      return {
        ...state,
        paymenthistory: action.payload.data,
      };
    }
    case GET_PAYMENT_TYPE_DETAILS: {
      return {
        ...state,
        customer_payment_method: action.payload.data,
      };
    }
    case GET_HOW_IT_WORKS_CMS_DATA: {
      return {
        ...state,
        howitworks_cms: action.payload.data,
      };
    }
    case SUBSCRIBED: {
      return {
        ...state,
        user_info: { ...state.user_info, isSubscribed: true },
      };
    }
    case GET_IS_PRO_MEMBER: {
      return {
        ...state,
        is_pro_member: action.payload,
      };
    }
    case GET_ACCOUNT_LOADER: {
      return {
        ...state,
        loader: action.payload,
      };
    }
    case INITIAL_LOADER: {
      return {
        ...state,
        initialLoader: action.payload,
      };
    }

    default:
      return state;
  }
};
export default accountReducers;
